import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Store from './store'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

if (sessionStorage.getItem("store")) {
    Store.replaceState(Object.assign({}, Store.state, JSON.parse(sessionStorage.getItem("store"))))
}

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            iconCls: 'el-icon-menu',
            hidden: true,
            component: () => import('./views/Login.vue')
        },
        { path: '/regStep1', component: () => import('./views/RegisterStep_1.vue'), name: '注册1' },
        { path: '/regStep2', component: () => import('./views/RegisterStep_2.vue'), name: '注册2' },
        {
            path: '/',
            name: 'home',
            component: Home,
            children: [
                { path: '/index', component: () => import('./views/Index.vue'), name: '数据展示' },
                { path: '/about', component: About, name: '关于' },
                { path: '/users', component: () => import('./views/auth/Users.vue'), name: '用户管理' },
                { path: '/systemRole', component: () => import('./views/auth/SystemRoleManager.vue'), name: '角色管理' },
                { path: '/systems', component: () => import('./views/auth/Systems.vue'), name: '系统管理' },
                { path: '/systemRouter', component: () => import('./views/auth/SystemRouterManager.vue'), name: '路由管理' },
                { path: '/loginRecord', component: () => import('./views/auth/UserLoginRecord.vue'), name: '登录日志' },
                { path: '/agentList', component: () => import('./views/agent/AgentInfo.vue'), name: '代理商信息管理' },
                { path: '/agentSettlement', component: () => import('./views/agent/AgentSettlement.vue'), name: '代理结算管理' },
                // { path: '/childAgentList', component: () => import('./views/agent/ChildAgentInfo.vue'), name: '下级代理商信息管理' },
                { path: '/merchantList', component: () => import('./views/merchant/MerchantInfo.vue'), name: '商户信息管理' },
                // { path: '/agentMerchantList', component: () => import('./views/merchant/AgentMerchantInfo.vue'), name: '代理商商户信息管理' },
                { path: '/orderList', component: () => import('./views/order/OrderInfo.vue'), name: '代收订单' },
                { path: '/order/paymentCodeCreate', component: () => import('./views/order/PaymentCodeCreate.vue'), name: '创建收款码' },
                // { path: '/orderCollection', component: () => import('./views/order/OrderCollection.vue'), name: '代收订单' },
                { path: '/orderPayment', component: () => import('./views/order/OrderPayment.vue'), name: '代付订单' },
                // { path: '/profitOrderList', component: () => import('./views/order/ProfitOrderInfo.vue'), name: '分润订单信息管理' },
                // { path: '/profitAgentList', component: () => import('./views/order/ProfitOrderInfoForAgent.vue'), name: '分润订单信息管理' },
                // { path: '/agentOrderList', component: () => import('./views/order/AgentOrderInfo.vue'), name: '代理商订单信息管理' },
                // { path: '/merOrderList', component: () => import('./views/order/MerOrderInfo.vue'), name: '订单信息管理' },
                // { path: '/deviceList', component: () => import('./views/device/DeviceInfo.vue'), name: '设备信息管理' },
                // { path: '/merDeviceList', component: () => import('./views/device/MerDeviceInfo.vue'), name: '设备信息管理' },
                // { path: '/agentDeviceList', component: () => import('./views/device/AgentDeviceInfo.vue'), name: '设备信息管理(代理商)' },
                { path: '/withdrawList', component: () => import('./views/withdraw/WithdrawInfo.vue'), name: '提现申请' },
                { path: '/rechargeList', component: () => import('./views/withdraw/RechargeInfo.vue'), name: '充值申请' },
                { path: '/merWithdrawList', component: () => import('./views/withdraw/MerWithdrawInfo.vue'), name: '提现管理' },
                { path: '/agentWithdrawList', component: () => import('./views/withdraw/AgentWithdrawInfo.vue'), name: '提现管理' },
                // { path: '/deviceAccount/:deviceToken', component: () => import('./views/device/DeviceAccountInfo.vue'), name: '设备信息' },
                { path: '/route/routeChannelInfo', component: () => import('./views/route/RouteChannelInfo.vue'), name: '渠道信息管理' },
                { path: '/route/routeConfigInfo', component: () => import('./views/route/RouteConfigInfoList.vue'), name: '路由信息管理' },
                // { path: '/walletInfo', component: () => import('./views/merchant/WalletInfo.vue'), name: '钱包管理' },
                // { path: '/flowInfo', component: () => import('./views/merchant/MerchantFlowInfo.vue'), name: '商户流水' },
                // { path: '/merFlowInfo', component: () => import('./views/merchant/MerchantFlowForMerInfo.vue'), name: '商户流水' },
                // { path: '/agentRouteConfigInfo', component: () => import('./views/agent/AgentRouteConfigInfoList.vue'), name: '代理商分润配置' },
                { path: '/capitalList', component: () => import('./views/capital/CapitalInfo.vue'), name: '资金管理' },
                { path: '/apiKey', component: () => import('./views/developer/ApiKey.vue'), name: 'API密钥' },
                { path: '/operateList', component: () => import('./views/developer/OperateInfo.vue'), name: '操作日志' },
                { path: '/streamList', component: () => import('./views/capital/StreamInfo.vue'), name: '资金流水' },
                { path: '/statisticsMerchant', component: () => import('./views/merchant/StatisticsMerchant.vue'), name: '商户报表' },
                { path: '/freezeBalance', component: () => import('./views/merchant/freezeBalance.vue'), name: '冻结管理' },
                { path: '/statisticsPlatform', component: () => import('./views/order/StatisticsPlatform.vue'), name: '经营报表' },
                { path: '/message', component: () => import('./views/developer/message.vue'), name: '消息通知' },
                { path: '/statisticsChannel', component: () => import('./views/route/StatisticsChannel.vue'), name: '渠道报表' },
                { path: '/bizSettlement', component: () => import('./views/order/bizSettlement.vue'), name: '商务报表' },
                { path: '/route/statisticsBank', component: () => import('./views/route/StatiscsBank.vue'), name: '银行报表' },

                { path: '/statisticChart', component: () => import('./views/statisticChart.vue'), name: '统计大盘' },

                { path: '*', component: () => import('./views/NotFound.vue'), name: '此页面不存在' },
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.path === "/login" || to.path === "/logout") {
        next();
    } else {
        if (Store.state.token === null || Store.state.token === "") {
            next({ path: '/login' })
        } else if (to.path === "/") {
            console.log(Store.state.routes)
            if (Store.state.routes[0].subList.length) {
                next({ path: Store.state.routes[0].subList[0].url })
            } else {
                next({ path: Store.state.routes[0].url })
            }

        } else {
            next();
        }
    }
})

export default router
